import styled, { keyframes } from 'styled-components';

const Header = styled.div`
    display: flex;
    margin-top: 20px;
    width: 900px;
    height: 500px;
    background-color:#000000;
    border: 1px solid #1B1B1B;
    box-shadow: 0px 8px 30px #000000;
    border-radius: 15px;
`;

const HeaderH1 = styled.h1`
    display: flex;
    margin-top: 250px;
    font-family: 'Fira code';
    font-style: normal;
    font-weight: 450;
    font-size: 24px;
    line-height: 18px;
    letter-spacing: 0.01em;

    color: #FF0000;
`;

const KeyAnim = keyframes`
    from{
        background-color: transparent;  
    }
    to{
        background-color: #FF0000;    
    }
`;
const HeaderAnim = styled.h2`
    position: relative;
    width: 10px;
    height: 25px;
    top: -5px;
    animation: ${KeyAnim} 500ms linear infinite;;
`;


const Projetos = () => {
    return (
        <Header>
            <HeaderH1>Em desenvolvimento...{<HeaderAnim />}</HeaderH1>
        </Header>
    );
};

export default Projetos;
